module.exports = __webpack_public_path__ + "static/media/3.40132b4d.JPG";